import { gql } from 'apollo-boost';
import { classBookQuery } from '../../../services/constants';
import { classBookQueryWithoutStudentsClass } from '../../../services/constants';

export const ISP_TEMPLATES = gql`
    query filteredBookTemplates($ispStarters: Boolean) {
        filteredBookTemplates(ispStarters: $ispStarters) {
            id
            name
            ispStarter
            editableTitle
            isSingleChapter
            resourcesUrl
            coverUrl
            chapters {
                id
                title
                content
                description
                orderid
                guidance
            }
            genre {
                id
                name
            }
        }
    }
`;

export const ASSIGN_BOOK_TEMPLATE_TO_CLASS = gql`
mutation assignBookTemplateToClass($studentsClassId: ID!, $bookTemplateId: ID!, $numberOfChapters: Int!) {
    assignBookTemplateToClass(studentsClassId: $studentsClassId, bookTemplateId: $bookTemplateId, numberOfChapters: $numberOfChapters) {
        errors
        classBook {
            ${classBookQuery}
        }
    }
}
`;

export const ASSIGN_BOOK_TEMPLATE_TO_GROUP = gql`
mutation assignBookTemplateToGroup($groupId: ID!, $bookTemplateId: ID!, $numberOfChapters: Int!) {
    assignBookTemplateToGroup(groupId: $groupId, bookTemplateId: $bookTemplateId, numberOfChapters: $numberOfChapters) {
        errors
        classBook {
            ${classBookQuery}
        }
    }
}
`;

export const GET_CLASS_STUDENTS = gql`
    query studentsClass($id: ID!) {
        studentsClass(id: $id) {
            id
            students {
                id
                avatarUrl
                boomerAvatarUrl
                displayName
                classes {
                    id
                    name
                }
            }
        }
    }
`;

export const ARCHIVE_RESTORE_BOOKS = gql`
    mutation archiveRestoreClassBooks(
        $classBookIds: [ID!]!
        $archived: Boolean!
    ) {
        archiveRestoreClassBooks(
            classBookIds: $classBookIds
            archived: $archived
        ) {
            errors
        }
    }
`;

export const DELETE_BOOK = gql`
    mutation deleteClassBook($classBookId: ID!) {
        deleteClassBook(classBookId: $classBookId) {
            errors
        }
    }
`;

export const BOOK_TEMPLATE_CATEGORY = gql`
    query bookTemplateCategories {
        bookTemplateCategories {
            backgroundColor
            iconUrl
            textColor
            bookTemplates {
                id
                name
                ispStarter
                editableTitle
                isSingleChapter
                resourcesUrl
                coverUrl
                chapters {
                    id
                    title
                    content
                    description
                    orderid
                    guidance
                }
                genre {
                    id
                    name
                }
            }
            description
            genres {
                id
                name
            }
            id
            isSingleChapter
            name
            subcategories {
                id
                name
                description
                backgroundColor
                iconUrl
                textColor
                bookTemplates {
                    id
                    name
                    ispStarter
                    editableTitle
                    isSingleChapter
                    resourcesUrl
                    coverUrl
                    chapters {
                        id
                        title
                        content
                        description
                        orderid
                        guidance
                    }
                    genre {
                        id
                        name
                    }
                }
            }
        }
    }
`;

export const GET_GROUPS = gql`
    query getGroups($schoolId: ID!) {
        getGroups(schoolId: $schoolId) {
            id
            name
            createdAt
            school {
                id
            }
            students {
                id
                avatarUrl
                boomerAvatarUrl
                displayName
                classes {
                    name
                }
            }
        }
    }
`;

export const CREATE_GROUP = gql`
    mutation addGroup(
        $schoolId: ID!
        $studentsClassId: ID!
        $name: String!
        $studentsIds: [ID!]!
    ) {
        addGroup(
            schoolId: $schoolId
            studentsClassId: $studentsClassId
            name: $name
            studentsIds: $studentsIds
        ) {
            errors
        }
    }
`;

export const DELETE_GROUPS = gql`
    mutation deleteGroups($groupIds: [ID!]!) {
        deleteGroups(groupIds: $groupIds) {
            errors
        }
    }
`;

export const RENAME_GROUP = gql`
    mutation renameGroup($groupId: ID!, $name: String!) {
        renameGroup(groupId: $groupId, name: $name) {
            errors
        }
    }
`;

export const ASSIGN_STUDENTS_TO_GROUP = gql`
    mutation assignStudentsToGroup($groupId: ID!, $studentIds: [ID!]!) {
        assignStudentsToGroup(groupId: $groupId, studentIds: $studentIds) {
            errors
        }
    }
`;

export const DELETE_STUDENTS_FROM_GROUP = gql`
    mutation removeStudentsFromGroup($groupId: ID!, $studentIds: [ID!]!) {
        removeStudentsFromGroup(groupId: $groupId, studentIds: $studentIds) {
            errors
        }
    }
`;
